<template>
    <div>
        <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg')">
            <div class="d-flex align-items-center justify-content-center h-100 py-5">
                <div class="container-fluid">
                    <div class="row justify-content-center align-items">
                        <div class="col-lg-5 col-md-8 col-11 text-center">
                            <p v-if="waiting"><i class="fa fa-spin fa-spinner"></i> Loading...</p>
                            <p v-if="!waiting"><i class="fa fa-info-circle"></i> Invalid token login, please try again</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AuthView',
        metaInfo: {
            title: 'Authentication Landing',
            titleTemplate: '%s - Rasionalisasi Rapor'
        },
        data() {
            return {
                waiting : false
            }
        },
        created() {
            if ((this.$route.params.token !== undefined) && (this.$route.params.token !== null) && (this.$route.params.token !== "")) {
                this.authLogin(this.$route.params.token);
            }
        },
        methods: {
            authLogin: function(token) {
                this.waiting = true;
                this.$http.get(process.env.VUE_APP_APIHOST + 'users/info', {
                    headers: {
                        'Authorization': token
                    }
                })
                .then(response => {
                    this.waiting = false;

                    if(response.data.logged_in) {
                        localStorage.setItem('gaspol_token', token);
                        location.reload();                        
                    } else {
                        alert("invalid token");
                    }
                })
            }               
        },
    }
</script>